import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, Typography } from '@mui/material';
import { closeBtn, dialogActions, dialogTitle, paperProps, title, deleteBtn } from './DeleteModal.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SuccessModal from 'app/components/SuccessModal';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  headerText: string;
}

const DeleteModal = (props: Props) => {
  const { open, close, headerText } = props;
  const [successModal, setSuccessModal] = useState(false);

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => close(false)}
      >
        <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
          <Typography sx={title}>{headerText}</Typography>
          <Button
            color={'tertiary'}
            onClick={() => {
              close(false);
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogActions sx={dialogActions}>
          <Button
            sx={deleteBtn}
            onClick={() => {
              close(false);
              setSuccessModal(true);
            }}
          >
            Sil
          </Button>
          <Button
            color={'secondary'}
            sx={{ ml: '0 !important' }}
            onClick={() => {
              close(false);
            }}
          >
            Ləğv et
          </Button>
        </DialogActions>
      </Dialog>
      <SuccessModal open={successModal} close={setSuccessModal} successText={'Əməkdaş siyahıdan uğurla silindi.'} />
    </>
  );
};

export default DeleteModal;
